import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import StandingsTables from "@/components/feature/StandingsTables";
import { useAnalytics } from "@/hooks/useAnalytics";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function JogosPage() {
  useAnalytics("/jogos");
  usePageSeo({
    title: "Jogos do Botafogo | Tabela, classificacao e proximas partidas",
    description: "Calendario, jogos, tabela e classificacao do Botafogo no Brasileirao e competicoes internacionais.",
    keywords: "Botafogo, jogos do Botafogo, tabela do Botafogo, classificacao Botafogo, Brasileirao, Copa do Mundo",
  });

  return (
    <div className="min-h-screen bg-white relative">
      <Navbar />

      <div className="absolute top-0 left-0 right-0 h-48 md:h-64 bg-gradient-to-b from-alvinegro-black to-white z-0" />

      <main className="pt-20 md:pt-24 pb-12 relative z-10">
        <div className="w-full px-4 md:px-8">
          <Breadcrumb items={[{ label: "Início", path: "/" }, { label: "Jogos" }]} />

          <div className="mb-4">
            <h1 className="font-serif font-bold text-3xl md:text-4xl text-alvinegro-black mb-4">
              Jogos
            </h1>

            <p className="text-alvinegro-muted text-base">
              Classificação e jogos do Campeonato Brasileiro.
            </p>
          </div>

          <StandingsTables
            withContainer={false}
            brasileiraoHeight={1500}
            internacionalHeight={1500}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}
